import auth from './auth'
import admin from './admin'
import outputs from './outputs'
import templates from './templates'
import sources from './sources'
import entities from './entities'
import dictionaries from './dictionaries'
import imports from './imports'
import views from './views'
import users from './users'

const mocks = [
    auth,
    admin,
    outputs,
    templates,
    sources,
    entities,
    dictionaries,
    imports,
    views,
    users,
]
const endpoints = [
    // Auth
    'auth.signin',

    // Admin
    'admin.usersList',
    'admin.usersCreate',
    // 'admin.usersDetail',
    'admin.usersEdit',
    'admin.usersDelete',

    // User
    'users.me',

    // Outputs
    'outputs.get',
    'outputs.update',
    'outputs.historic',
    'outputs.edit',
    'outputs.detail',
    'outputs.delete',
    'outputs.deleteMultiple',

    // Views
    'views.list',
    'views.create',
    'views.get',
    'views.update',
    'views.remove',

    // Templates
    'templates.list',
    'templates.download',

    // Sources
    'sources.list',

    // Entities
    'entities.schema',
    'entities.transforms',
    'entities.styles',
    'entities.validators',
    'entities.search',

    'entities.create',
    'entities.update',
    'entities.delete',
    'entities.merge',

    // Dictionaries
    'dictionaries.list',
    'dictionaries.get',
    'dictionaries.delete',
    'dictionaries.edit',
    'dictionaries.fieldCreate',
    'dictionaries.fieldDelete',
    'dictionaries.fieldEdit',

    // Imports
    'imports.list',
    'imports.create',
    'imports.get',
    'imports.remove',
    'imports.update',
    'imports.save',
    'imports.cancel',
    'imports.files',

    'imports.getSource',
    'imports.editSource',
    'imports.deleteSource',
]

export default {
    endpoints,
    mocks,
}
